import { OrderItem, OrderItemType } from '@mews-commander/data-access';

type ProductOrderOrderItem = OrderItem & { data: { discriminator: OrderItemType.ProductOrder } };

export const isOrderItemProductOrder = (orderItem: OrderItem): orderItem is ProductOrderOrderItem =>
    orderItem.data.discriminator === OrderItemType.ProductOrder;

export const isOrderItemClaimed = (orderItem: OrderItem): boolean => !!orderItem.claimedUtc;

export const getOrderItemMultiplier = (orderItem: OrderItem) =>
    orderItem.timeMultiplier * orderItem.unitMultiplier * orderItem.personMultiplier;

export const getOrderItemUnclaimedCount = (orderItem: OrderItem) =>
    !orderItem.claimedCount
        ? getOrderItemMultiplier(orderItem)
        : orderItem.claimedCount - getOrderItemMultiplier(orderItem);
